import { cn } from '../lib/cn';
import { initials } from '../lib/format';

const SIZES = {
  sm: 'w-6 h-6 text-[10px]',
  md: 'w-8 h-8 text-xs',
  lg: 'w-10 h-10 text-sm',
  xl: 'w-12 h-12 text-base',
};

/**
 * Lettered avatar with optional image.
 *
 * Mercury uses a circular monochrome avatar with letter-pair initials when no
 * logo is available. We do the same — a neutral pill that holds focus on the
 * data, never on the avatar.
 */
export function Avatar({
  name,
  src,
  size = 'md',
  className,
}: {
  name: string;
  src?: string;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={cn(
          'rounded-full object-cover bg-zinc-100 dark:bg-zinc-800',
          SIZES[size],
          className,
        )}
      />
    );
  }
  return (
    <span
      aria-label={name}
      className={cn(
        'rounded-full grid place-items-center font-medium select-none',
        'bg-zinc-100 text-zinc-700',
        'dark:bg-zinc-800 dark:text-zinc-200',
        SIZES[size],
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}
